import path$1 from './path.js';
import hasOwnProperty_1 from './has-own-property.js';
import './well-known-symbol-wrapped.js';
import './object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';
import { __exports as wellKnownSymbolWrapped } from '../../../../../../_virtual/well-known-symbol-wrapped.js';

var path = path$1;
var hasOwn = hasOwnProperty_1;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineProperty = objectDefineProperty.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};

export { defineWellKnownSymbol as default };
